import { Provider } from "jotai";
import { IAvisEditableListProps, AvisEditableListJotaiHoc } from ".";
import { isMobileView } from "../../appStates/appStates";

export function AvisEditableList<T extends object, P extends object>(
  props: Readonly<IAvisEditableListProps<T, P>>,
) {
  const { view } = props;
  const getViewMode = () => {
    if (!view) return isMobileView.value ? "description-list" : "table";

    return view;
  };
  return (
    <div className="avis-editable-list avis-box-shadow">
      <Provider>
        <AvisEditableListJotaiHoc<T, P> {...props} view={getViewMode()} />
      </Provider>
    </div>
  );
}
